import LazyLoadImg from "components/LazyLoadImg";
import { BsPlayCircle } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { addStationToRadio } from "redux/AudioPlayerRedux";
import AddRadioToFav from "./AddRadioToFav";
import { useState } from "react";
import { Link } from "react-router-dom";
import { RouteName } from "constant/routeNames";
import { FaCrown } from "react-icons/fa";
import { ContentType } from "services/subscription/types";
import { usePremiumAccess } from "hooks/usePremiumAccess";
import PremiumContentModal from "components/PremiumContentModal";

function RadioCard({ station, user, favorite, is_creator }: any) {
  const [underline, setUnderline] = useState<boolean>(false);
  const dispatch = useDispatch<any>();
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);

  const { isModalOpen, setIsModalOpen, checkAccess } = usePremiumAccess();

  const isPremiumContent = station?.plan_id === 2;
  const isPlusUser = loggedInUser?.is_subscribed;

  const handleRadio = async () => {
    const access = await checkAccess({
      contentType: ContentType.RADIO_STATIONS,
      id: station?.id,
      isPremiumContent,
      isCreator: is_creator,
    });
    if (!access) return;

    dispatch(addStationToRadio(station));
  };

  const packageObject: any = {
    id: station?.service_id || station?.id,
    entitlement_id: station?.entitlement_id || "",
    title: station?.title,
    price: station?.price || "",
    thumbnail: station?.artwork_url || "",
    created_at: station?.created_at || "",
    description: station?.description || "",
    is_subscribed: station?.is_subscribed || false,
    role_id: station?.plan_id,
    slug: station?.slug,
  };

  return (
    <>
      <PremiumContentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        isCreator={is_creator}
        packageObject={packageObject}
      />

      <div className="group mb-[15px] block w-full cursor-pointer rounded-xl px-2 py-2 text-white shadow-lg transition-all duration-300 ease-out hover:-translate-y-1 hover:bg-slate-800 hover:text-slate-300 hover:shadow-xl">
        {/* image */}
        <div className="bg-img white-text relative aspect-square w-full overflow-hidden rounded-lg ring-1 ring-white/5 transition-all duration-300 group-hover:ring-2 group-hover:ring-[var(--red)]/40">
          <LazyLoadImg
            imgSrc={station?.artwork_url}
            imgAlt={station?.title}
            imgHeight={"100%"}
            imgWidth={"100%"}
            wrapperProps={{
              style: {
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                display: "block",
              },
            }}
            className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />

          {/* Premium pill */}
          {isPremiumContent && (
            <div className="absolute left-2 top-2 z-10 flex items-center gap-1 rounded-full border border-white/15 bg-black/40 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white shadow-lg backdrop-blur-md">
              <FaCrown className="text-[10px] text-[var(--red)]" />
              <span>Premium</span>
            </div>
          )}

          {/*centralize  play icon */}
          <button
            className="add-button absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 items-center rounded-full p-1 hover:shadow-2xl"
            onClick={handleRadio}
          >
            <BsPlayCircle className="action-icon-size text-md my-auto h-12 w-12 duration-300 ease-in-out hover:text-red-600" />
          </button>

          {/* card inside content */}
          <div className="absolute inset-x-0 bottom-0 mb-2 flex w-full justify-end p-2 pr-3">
            {loggedInUser && user?.id === loggedInUser?.id && (
              <div className="add-button items-center rounded-full p-1">
                <AddRadioToFav station={station} RadioCard={true} />
              </div>
            )}
          </div>
        </div>
        <div className="relative top-1">
          <Link
            to={RouteName.RadioDescriptionRoute.replace(":slug", station?.slug)}
            className="flex"
            onMouseEnter={() => {
              setUnderline(true);
            }}
            onMouseLeave={() => {
              setUnderline(false);
            }}
          >
            <div className="my-[4px]">
              <p
                className={`text-[15px] font-[600] text-white ${
                  underline && `underline`
                }`}
              >
                {station.title}
              </p>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}

export default RadioCard;